import { makeStyles, MenuItem, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getMachineSlots, getSortingMachines, getSortingWarehouses } from "../../actions/sortingMachineManagementActions";
import sortingModes from '../../constants/sortingModes.json';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex'
    },
    textField: {
        width: 200,
        marginRight: 20
    }
}))

function FilterConfig(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation('sortingMachineManagement');

    const sortingMachines = useSelector(state => state.smmReducer.sortingMachines);
    const searchItems = useSelector(state => state.smmReducer.searchItems);
    const preset = useSelector(state => state.smmReducer.preset);

    const [planName, setPlanName] = useState('');
    const [sortingCenter, setSortingCenter] = useState();
    const [sortingMachine, setSortingMachine] = useState();
    const [sortingMode, setSortingMode] = useState();
    const [totalGrids, setTotalGrids] = useState();

    useEffect(() => {
        if (sortingCenter) {
            dispatch(getSortingMachines(sortingCenter));
            dispatch(getSortingWarehouses(sortingCenter));
        }
    }, [sortingCenter])

    useEffect(() => {
        if (sortingMachine) {
            const machinConfig = sortingMachines.filter((machine) => {
                return machine.machine_code === sortingMachine;
            })
            dispatch(getMachineSlots(sortingMachine))
                .then((res) => {
                    setTotalGrids(res);
                })
        } else {
            setTotalGrids([]);
        }
    }, [sortingMachine])

    useEffect(() => {
        props.handleTotalGrids(totalGrids);
    }, [totalGrids])

    useEffect(() => {
        props.handleFilterParams(planName, sortingMachine, sortingMode)
    }, [planName, sortingMachine, sortingMode])

    useEffect(() => {
        if (props.type === 'EDIT' && props.open) {
            setPlanName(preset?.preset?.name);
            setSortingCenter(searchItems?.sortingCenter);
            setSortingMachine(searchItems?.machineCode);
            setSortingMode(searchItems?.sortingType);
        } else {
            setPlanName('');
            setSortingCenter('');
            setSortingMachine('');
            setSortingMode('');
            setTotalGrids([]);
        }
    }, [])

    return (
        <div className={classes.root}>
            <div>
                <TextField
                    label={t('plan_name')}
                    value={planName}
                    onChange={(e) => setPlanName(e.target.value)}
                    fullWidth
                    className={classes.textField}
                    variant='outlined'
                />
            </div>
            <div>
                <TextField
                    select
                    label={t('sorting_center')}
                    defaultValue={(props.type === 'EDIT' && props.open) ? searchItems.sortingCenter : ''}
                    value={sortingCenter}
                    onChange={(e) => setSortingCenter(e.target.value)}
                    fullWidth
                    className={classes.textField}
                    variant='outlined'
                >
                    {
                        props.sortingCenters?.length > 0 &&
                        props.sortingCenters.map((center) => (
                            <MenuItem value={center.id}>{center.name}</MenuItem>
                        ))
                    }
                </TextField>
            </div>
            <div>
                <TextField
                    select
                    fullWidth
                    defaultValue={(props.type === 'EDIT' && props.open) ? searchItems.machineCode : ''}
                    value={sortingMachine}
                    variant="outlined"
                    onChange={(e) => setSortingMachine(e.target.value)}
                    label={t('sorting_machine')}
                    disabled={!sortingCenter}
                    className={classes.textField}
                >
                    {
                        sortingMachines?.length > 0 &&
                        sortingMachines.map((machine) => (
                            <MenuItem value={machine.machine_code}>{machine.machine_code}</MenuItem>
                        ))
                    }
                </TextField>
            </div>
            <div>
                <TextField
                    select
                    fullWidth
                    defaultValue={(props.type === 'EDIT' && props.open) ? searchItems.sortingType : ''}
                    value={sortingMode}
                    variant="outlined"
                    onChange={(e) => {
                        setSortingMode(e.target.value)
                    }}
                    label={t('sorting_mode')}
                    className={classes.textField}
                >
                    {
                        sortingModes.map((mode) => (
                            <MenuItem value={mode.id}>{t(`${mode.name}`)}</MenuItem>
                        ))
                    }

                </TextField>
            </div>
        </div>
    );
}
export default FilterConfig;